var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraphStatsDescend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2734 5.64844V8.8125H8.10938",
    stroke: "#F51D1D",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2734 8.8125L7.55203 5.09109C7.48673 5.02575 7.4092 4.97393 7.32384 4.93856C7.23853 4.9032 7.14708 4.88499 7.05469 4.88499C6.9623 4.88499 6.87084 4.9032 6.78553 4.93856C6.70017 4.97393 6.62264 5.02575 6.55734 5.09109L5.09109 6.55734C5.0258 6.62269 4.94827 6.67453 4.86293 6.70987C4.77759 6.74522 4.68612 6.76345 4.59375 6.76345C4.50138 6.76345 4.40991 6.74522 4.32457 6.70987C4.23923 6.67453 4.1617 6.62269 4.09641 6.55734L0.726562 3.1875",
    stroke: "#F51D1D",
    strokeWidth: 1.07143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphStatsDescend);
export default __webpack_public_path__ + "static/media/graph-stats-descend.29c5725abdb1a0119cc4f31e02f4890e.svg";
export { ForwardRef as ReactComponent };